import {splitArrayInNArraysByLength} from '../../../../serp/services/utils';
import * as _ from 'lodash';

export default [
  '$window',
  '$scope',
  '$timeout',
  'RegionUtilsService',
  'FilterService',
  'RegionCityBrowserService',
  '$uibModalInstance',
  'modalClass',
  'RegionIds',
  'MetaService',
  'AnalyticsService',
  function (
    $window,
    $scope,
    $timeout,
    RegionUtilsService,
    FilterService,
    RegionCityBrowserService,
    $uibModalInstance,
    modalClass,
    RegionIds,
    MetaService,
    AnalyticsService
  ) {
    const ctrl = this;

    /**
     * @type {HTMLElement}
     */
    let modalContentEl;

    /**
     * @param {?Region[]} regions
     * @return {Boolean}
     */
    const isMoscowOrStPetersburg = regions => {
      return regions.length === 1 && (regions[0].id === RegionIds.REGIONS.MOSCOW || regions[0].id === RegionIds.REGIONS.SPB);
    };

    /**
     * @param {?Region[]} regions
     */
    ctrl.select = regions => {
      // Сохраняем выбор
      if (regions) {
        FilterService.setRegions(regions);

        // Если выбрана группа, то показываем её детей
        if (RegionUtilsService.findGroup(regions)) {
          ctrl.customRegions = regions.map(r => ({
            text: r.text,
            value: [r],
          }));
          ctrl.groupSelected = true;
          ctrl.regionsByColumns = null;
        } else {
          //Сбрасываем выбор группы если не выбран город из неё (только Москва и Санкт-Петербург)
          if (regions[0].id !== RegionIds.REGIONS.MOSCOW && regions[0].id !== RegionIds.REGIONS.SPB) {
            ctrl.customRegions = null;
            ctrl.groupSelected = false;
          }
        }

        // Если город из группы (Москва или Санкт-Петербург)
        if (isMoscowOrStPetersburg(regions)) {
          ctrl.parentGroup = RegionCityBrowserService.findContainingGroup(regions[0]);
          if (ctrl.parentGroup) {
            ctrl.customRegions = ctrl.parentGroup.value.map(r => ({
              text: r.text,
              value: [r],
            }));
            ctrl.groupSelected = false;
            ctrl.regionsByColumns = null;
          }
        } else {
          ctrl.parentGroup = null;
        }

        ctrl.isRegionSelected = true;
      } else {
        // Выбрана "Россия"
        ctrl.isRegionSelected = false;
        ctrl.customRegions = RegionCityBrowserService.regionGroups;
      }

      let searchRegions = regions;
      if (regions && regions.length === 1 && regions[0].isCity()) {
        searchRegions = [_.find(RegionCityBrowserService.topRegions, {id: regions[0].parentId})]
      }
      // Обновляем список регионов
      ctrl.isLoading = true;
      RegionCityBrowserService.getChildrenRegions(searchRegions)
        .then(childrenRegions => {
          if (childrenRegions.length > 0) {
            ctrl.regionsByColumns = splitArrayInNArraysByLength(
              RegionCityBrowserService.groupByFirstLetter(childrenRegions),
              'regions'
            );
          }
          ctrl.selectedRegion = regions && regions.length === 1 ? regions[0] : null;
        })
        .catch(() => ctrl.regionsByColumns = null)
        .finally(() => {
          ctrl.isLoading = false;

          // Позволяем тайпахэду выходить за рамки попапа, если попап маленький по высоте
          modalContentEl.style.overflow = 'auto';
          $timeout(() => {
            // Опытным путём установил, что в IE у cui-modal__content'а
            // scrollHeight всегда как минимум на 1 пиксель больше offsetHeight.
            // Обрезание тайпахэда хуже, чем растягивание попапа на всю высоту,
            // поэтому добавил небольшой зазор.
            // Если попап влезает в экран или вылезает на DELTA_PX пикселей,
            // то в нём не будет скролла.
            const DELTA_PX = 5;
            if (modalContentEl.scrollHeight - modalContentEl.offsetHeight <= DELTA_PX) {
              modalContentEl.style.overflow = 'visible';
            }
          }, 0, false);

          // Форсируем reflow, чтобы плашка "Сохранить" не осталась висеть посередине модала
          triggerReflow();
        });

      // Обновляем хлебные крошки
      ctrl.breadcrumbs = RegionCityBrowserService.getRegionPath(regions);

      // Очищаем поиск
      ctrl.searchText = '';
    };

    ctrl.isBreadcumbSelected = breadcrumbValue => {
      if (breadcrumbValue) {
        if (breadcrumbValue.length > 1) {
          return ctrl.groupSelected;
        } else {
          return ctrl.selectedRegion ?
            breadcrumbValue[0].id === ctrl.selectedRegion.id : false;
        }
      }
      return false;
    };

    ctrl.suggest = query => {
      if (query) return RegionCityBrowserService.searchRegions(query);
    };

    ctrl.save = () => {
      if (ctrl.isRegionSelected) {
        AnalyticsService.trackCA('Listing', 'popup_GEO_save', MetaService.lastMeta && MetaService.lastMeta.url, {});
        $uibModalInstance.close();
      } else {
        $uibModalInstance.dismiss();
      }
    };

    ctrl.selectRegion = region => ctrl.select([region]);

    ctrl.selectParent = region => {
      if (ctrl.parentGroup) {
        ctrl.select(
          ctrl.parentGroup.value
        );
      } else {
        ctrl.selectRegion(
          _.find(RegionCityBrowserService.topRegions, { id: region.parentId })
        );
      }
    };

    ctrl.selectCustomRegion = regionValue => {
      ctrl.select(regionValue);
    };

    // Открытие попапа
    ctrl.isLoading = true;
    $uibModalInstance.rendered.then(() => {
      ctrl.isLoading = false;
      modalContentEl = $window.document.querySelector(`.${modalClass} .cui-modal__content`);
      ctrl.select(FilterService.selectedRegions);
    });


    // Utils
    function triggerReflow() {
      $window.document.body.style.zoom = 1.000001;
      $timeout(() => $window.document.body.style.zoom = null, 0, false);
    }
  }];



// WEBPACK FOOTER //
// ./src/components/region-city-browser/src/scripts/cian.region-city-browser.ctrl.js